/**
 * Saved patient channel layouts (`app/services/patient_channel_layout_service.py`).
 *
 * Split out of `brainfocus_api.ts` (FE Arch 1.0, #1165), which re-exports everything
 * here through the `BrainFocusApi` facade. Requests go through `client.request` so tests
 * can stub it on the module namespace.
 */
import * as client from '@brainfocus/web/api/client';
import { assertPojo } from '@brainfocus/web/api/response';

// -- Patient-scoped named channel layouts (#617) ------------------------

export async function listPatientChannelLayouts(
    patientId: number,
): Promise<{ layouts: { id: number; name: string; updated_at: string | null }[] }> {
    const r = await client.request('GET', `/api/patients/${patientId}/channel-layouts`);
    assertPojo<{ layouts: { id: number; name: string; updated_at: string | null }[] }>(r);
    return r;
}

export async function getPatientChannelLayout(
    patientId: number,
    layoutId: number,
): Promise<{ id: number; name: string; layout: unknown }> {
    const r = await client.request('GET', `/api/patients/${patientId}/channel-layouts/${layoutId}`);
    assertPojo<{ id: number; name: string; layout: unknown }>(r);
    return r;
}

export async function createPatientChannelLayout(
    patientId: number,
    name: string,
    layout: unknown,
    overwrite = false,
): Promise<{ id: number }> {
    const r = await client.request('POST', `/api/patients/${patientId}/channel-layouts`, { name, layout, overwrite });
    assertPojo<{ id: number }>(r);
    return r;
}

export async function updatePatientChannelLayout(
    patientId: number,
    layoutId: number,
    update: { name?: string; layout?: unknown },
): Promise<void> {
    await client.request('PUT', `/api/patients/${patientId}/channel-layouts/${layoutId}`, update);
}

export async function deletePatientChannelLayout(patientId: number, layoutId: number): Promise<void> {
    await client.request('DELETE', `/api/patients/${patientId}/channel-layouts/${layoutId}`);
}
